import { setPreferredExperience } from '@/console/host/experience-storage';
import { ExperienceId } from '@/console/host/experience.types';

export const switchExperience = (experience: ExperienceId) => {
  setPreferredExperience(experience);
  window.location.assign(window.location.href);
};
